import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";
import ProjectOne from "../views/ProjectOne.vue";
import ProjectTwo from "../views/ProjectTwo.vue";
import ProjectThree from "../views/ProjectThree.vue";
import ProjectFour from "../views/ProjectFour.vue";
import ProjectFive from "../views/ProjectFive.vue";
import ProjectSix from "../views/ProjectSix.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/projects/one",
    name: "ProjectOne",
    component: ProjectOne,
  },
  {
    path: "/projects/two",
    name: "ProjectTwo",
    component: ProjectTwo,
  },
  {
    path: "/projects/three",
    name: "ProjectThree",
    component: ProjectThree,
  },
  {
    path: "/projects/four",
    name: "ProjectFour",
    component: ProjectFour,
  },
  {
    path: "/projects/five",
    name: "ProjectFive",
    component: ProjectFive,
  },
  {
    path: "/projects/six",
    name: "ProjectSix",
    component: ProjectSix,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 1000);
    });
  },
});

export default router;
